import React from 'react'
import PropTypes from 'prop-types'

import FacebookCampaignsSection from './FacebookCampaignsSection'
import GoogleCampaignsSection from './GoogleCampaignsSection'
import DV360CampaignsSection from './DV360CampaignsSection'
import TikTokCampaignsSection from './TikTokCampaignsSection'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../constants/selectLists/platformList'

function CampaignsSection({ showSection, onRowCheck, handleDeleteRequest }) {
  return (
    <>
      {showSection[FACEBOOK_PLATFORM] && (
        <FacebookCampaignsSection onRowCheck={onRowCheck} handleDeleteRequest={handleDeleteRequest} />
      )}
      {showSection[GOOGLE_PLATFORM] && <GoogleCampaignsSection />}
      {showSection[DV_360_PLATFORM] && <DV360CampaignsSection />}
      {showSection[TIKTOK_PLATFORM] && <TikTokCampaignsSection />}
    </>
  )
}

CampaignsSection.propTypes = {
  showSection: PropTypes.object.isRequired,
  onRowCheck: PropTypes.func
}

export default CampaignsSection
